import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/about/About-us-carousel-bubbles_mobile_306x54px.svg")